import { createFileRoute, Link } from '@tanstack/react-router'
import { formatArticleDate, PUBLISHED_ARTICLES } from '@/lib/articles'

const TITLE = 'Articles — Halo Compliance'
const DESCRIPTION =
  'Plain-language guidance on mortgage marketing compliance — advertising rules, disclosures, and the review habits that keep campaigns shippable.'

export const Route = createFileRoute('/articles/')({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: 'description', content: DESCRIPTION },
      { property: 'og:title', content: TITLE },
      { property: 'og:description', content: DESCRIPTION },
      { property: 'og:url', content: 'https://www.halocompliance.com/articles' },
    ],
    links: [{ rel: 'canonical', href: 'https://www.halocompliance.com/articles' }],
  }),
  component: ArticlesIndexPage,
})

function ArticlesIndexPage() {
  return (
    <div className="marketing-inner py-5">
      <div className="container py-4">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-9 text-center">
            <h1 className="display-5 font-serif mb-4">Articles</h1>
            <p className="lead text-body-secondary mb-0">{DESCRIPTION}</p>
          </div>
        </div>

        {PUBLISHED_ARTICLES.length === 0 ? (
          <div className="row justify-content-center">
            <div className="col-lg-9 text-center text-body-secondary">
              <p className="mb-0">No articles published yet — check back soon.</p>
            </div>
          </div>
        ) : (
          <div className="row justify-content-center g-4 row-cols-1 row-cols-md-2">
            {PUBLISHED_ARTICLES.map((article) => (
              <div key={article.slug} className="col">
                <article className="article-card position-relative h-100 rounded border overflow-hidden d-flex flex-column">
                  {article.image && (
                    <img
                      src={article.image}
                      alt={article.imageAlt ?? ''}
                      className="article-thumb w-100"
                      loading="lazy"
                    />
                  )}
                  <div className="p-4 d-flex flex-column flex-grow-1">
                    {article.draft && (
                      <span className="badge text-bg-warning align-self-start mb-3">
                        Draft — not published
                      </span>
                    )}
                    <p className="small text-body-secondary mb-2">
                      <time dateTime={article.date}>{formatArticleDate(article.date)}</time>
                      <span className="mx-2">·</span>
                      {article.author}
                    </p>
                    <h2 className="h5 mb-3">
                      <Link
                        to="/articles/$slug"
                        params={{ slug: article.slug }}
                        className="stretched-link text-decoration-none"
                      >
                        {article.title}
                      </Link>
                    </h2>
                    <p className="mb-0 text-body-secondary">{article.summary}</p>
                  </div>
                </article>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
